package com.example.mystybag.remoteLogger

import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.providers.BasicAuthCredentials
import io.ktor.client.plugins.auth.providers.basic
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.request.host
import io.ktor.http.URLProtocol

internal actual object LoggerRestConnection {

    private const val LOGGER_HOST = "dev-mobadmin.mystybags.eu"

    actual fun getLogHttpClient(): HttpClient = HttpClient(Js) {
        install(HttpTimeout) {
            requestTimeoutMillis = 30_000
        }
        install(Auth) {
            basic {
                credentials {
                    BasicAuthCredentials(username = "mystybagremotelog", password = "09mwnv,3484!oidlfg")
                }
                realm = "Restricted Access"
                sendWithoutRequest { request ->
                    request.host == LOGGER_HOST
                }
            }
        }
        defaultRequest {
            url {
                host = LOGGER_HOST
                protocol = URLProtocol.HTTPS
            }
        }
    }
}

internal actual fun parseDate(milliseconds: Long): String {
    val ld = Instant.fromEpochMilliseconds(milliseconds).toLocalDateTime(TimeZone.currentSystemDefault())
    val months = listOf("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec")
    val m = months.getOrNull(ld.monthNumber - 1) ?: ""
    return "${ld.dayOfMonth.toString().padStart(2, '0')}.${ld.monthNumber.toString().padStart(2, '0')}.${ld.year} ${ld.hour.toString().padStart(2, '0')}:${ld.minute.toString().padStart(2, '0')}:${ld.second.toString().padStart(2, '0')}.${(ld.nanosecond / 1_000_000).toString().padStart(3, '0')}"
}
